import React from "react";

const AstronautIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="35" fill="none" viewBox="0 0 52 35" {...props}>
      <path
        fill="#D9D9D9"
        d="M24.038 17.054a3 3 0 013.237 0l11.977 7.674c2.523 1.617 1.378 5.526-1.618 5.526H13.68c-2.996 0-4.142-3.91-1.619-5.526l11.977-7.674z"
      ></path>
      <ellipse cx="13.992" cy="12.934" fill="#5289E3" rx="1.495" ry="3.047"></ellipse>
      <ellipse cx="37.331" cy="12.934" fill="#5289E3" rx="1.495" ry="3.047"></ellipse>
      <ellipse cx="25.662" cy="12.187" fill="#D9D9D9" rx="11.67" ry="12.187"></ellipse>
      <rect width="19.085" height="14.946" x="16.176" y="5.519" fill="#0B132B" rx="7.473"></rect>
      <circle cx="30.433" cy="9.313" r="0.92" fill="#D9D9D9"></circle>
      <path
        fill="#5289E3"
        d="M34.642 21.95c-7.815 1.794-11.572 1.486-17.826 0l-2.875 1.753c6.316 1.06 8.684 2.093 23.432 0l-2.731-1.754z"
      ></path>
    </svg>
  );
};

export default AstronautIcon;
